import React from "react"
import styles from "./About.module.css"
import FadeInSection from "../FadeInSection/FadeInSection"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const About = () => {
  return (
    <StaticQuery
      query={graphql`
        query aboutUs {
          aboutUs: file(relativePath: { eq: "aboutUs.jpg" }) {
            childImageSharp {
              fluid(quality: 100, maxWidth: 5000, maxHeight: 5000) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      `}
      render={data => {
        // Set ImageData.
        const aboutUs = data.aboutUs.childImageSharp.fluid
        return (
          <div className={styles.container} id="about-page">
            <FadeInSection>
              <div className={styles.content}>
                <section className={styles.description}>
                  <h1 className="bigTitle">Who we are</h1>
                  <h2>A little about us</h2>
                  <div className="line"></div>
                  <p className="paragraph">
                    Right Choice Renovations is passionate in providing strong
                    customer satisfaction when it comes to home renovations and
                    offer a wide variety of services.
                    <br /> <br /> Our vision is to deliver residential
                    renovation and woodworking services at such a consistently
                    high level of quality, professionalism, ethics, reliability,
                    and integrity that we will set the standard for excellence
                    in the renovation industry.
                  </p>
                </section>
                <section className={styles.imageContainer}>
                  <Img fluid={aboutUs} alt="owners" />
                </section>
              </div>
            </FadeInSection>
          </div>
        )
      }}
    />
  )
}

export default About
